import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilsService } from 'src/app/core/utils.service';
import { LOGO_PLACEHOLDER_SRC } from '../constants/operationals';

@Component({
  selector: 'app-shared-store-logo',
  templateUrl: './shared-store-logo.component.html',
  styleUrls: ['./shared-store-logo.component.scss'],
})
export class SharedStoreLogoComponent {
  @Input() current_store_logo?: string | null;
  @Input() size: string = 'm';
  @Output() logo_click: EventEmitter<void> = new EventEmitter<void>();
  logo_placeholder_src: string = LOGO_PLACEHOLDER_SRC;

  constructor(private utils_service: UtilsService) {}

  getSizeClass(): string {
    return `sp-circle__${this.size}`;
  }

  getStoreLogo(): string {
    return this.utils_service.getStoreLogo(this.current_store_logo || undefined);
  }
}
